import { createContext } from "react";

export const issuesTabReferenceProviderContext = createContext<Boolean>(false);
